import { DatePicker2 } from '@alifd/next';
import wrapper from './next-wrapper';
const FormDateRangePicker = wrapper(DatePicker2.RangePicker, 'CbayelFormDateRangePicker');
export default FormDateRangePicker;
